import { NextPage } from 'next'
import css from 'styled-jsx/css'

import Catalog from '@ui/components/ministore/Catalog'
import Footer from '@ui/components/shared/Footer'
import Header from '@ui/components/shared/Header'
import Loading from '@ui/components/shared/Loading'
import { isPayingWithPaypalKey, useGlobalState } from '@libs/client'

const IndexPage: NextPage = () => {
  const [isPayingWithPaypal] = useGlobalState<boolean>(isPayingWithPaypalKey)

  return (
    <div className="product-page">
      <style jsx global>
        {globalStyle}
      </style>
      {isPayingWithPaypal ? (
        <Loading isFullWidth />
      ) : (
        <>
          <Header haveSaleBar />
          <Catalog />
          <Footer />
        </>
      )}
    </div>
  )
}

const globalStyle = css.global`
  .product-page {
    .top-description {
      margin-bottom: 61px;
    }
    .product {
      padding-top: 30px;
      padding-bottom: 105px;

      @media screen and (max-width: 768px) {
        padding-top: 0;
        padding-bottom: 48px;
      }

      &__rated {
        display: flex;
        align-items: center;
        font-size: 12px;

        .stars {
          margin-bottom: 4px;
          margin-left: 12px;
        }
      }
    }

    @media screen and (max-width: 768px) {
      .product-images {
        margin-bottom: 24px;
      }
    }

    .loading-component {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1;
      height: 100vh;
      width: 100vw;
    }
  }
`

export default IndexPage
